/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Type_Craniosacral_Therapy_TermsInputs */

const en_service_type_craniosacral_therapy_terms = /** @type {(inputs: Service_Type_Craniosacral_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`craniosacral, cranio`)
};

const pl_service_type_craniosacral_therapy_terms = /** @type {(inputs: Service_Type_Craniosacral_Therapy_TermsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`terapia czaszkowo krzyżowa, cranio, kranio`)
};

/**
* | output |
* | --- |
* | "craniosacral, cranio" |
*
* @param {Service_Type_Craniosacral_Therapy_TermsInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const service_type_craniosacral_therapy_terms = /** @type {((inputs?: Service_Type_Craniosacral_Therapy_TermsInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Type_Craniosacral_Therapy_TermsInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_service_type_craniosacral_therapy_terms(inputs)
	return en_service_type_craniosacral_therapy_terms(inputs)
});